import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtpSectionDirective } from './atp-section.directive';

@NgModule({
  declarations: [
    AtpSectionDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AtpSectionDirective
  ]
})
export class AtpSectionModule { }
